/** Temperatura de un lead a partir de su puntaje 0-100 (tablero "Atención del bot", ADR-017). */
export type AttentionTemperature = 'CALIENTE' | 'TEMPLADO' | 'FRIO';

export const ATTENTION_TEMPERATURE = { hot: 70, warm: 40 } as const;

export function temperatureOf(score: number): AttentionTemperature {
  if (score >= ATTENTION_TEMPERATURE.hot) return 'CALIENTE';
  if (score >= ATTENTION_TEMPERATURE.warm) return 'TEMPLADO';
  return 'FRIO';
}

export const TEMPERATURE_LABELS: Record<AttentionTemperature, string> = {
  CALIENTE: 'Caliente',
  TEMPLADO: 'Templado',
  FRIO: 'Frío',
};
